import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './Home';
import { Drug } from './Drug';
import { Kinase } from './Kinase';
import Cytokines from './Cytokines';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/kincyte' element={<Home />} />
        <Route path='/kincyte/drugs' element={<Drug />} />
        <Route path='/kincyte/kinases' element={<Kinase />} />
        <Route path='/kincyte/cytokines' element={<Cytokines />} />
      </Routes>
    </Router>
  );
}

export default App;